import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { SingleTenantConfig } from '@app/store/configs/single-tenant-config.type';

export const singleTenantActions = createActionGroup({
  source: 'App - Single tenant',
  events: {
    initialize: emptyProps(),
    loadConfig: emptyProps(),
    configLoaded: props<{ config: SingleTenantConfig }>(),
    missingConfig: emptyProps(),
  },
});
